import { Component, OnInit, ViewChild } from '@angular/core';
import { LearningResourceService } from '../common/services/learning-resource.service';
import { LearningResource } from '../common/models/learningResource';
import { UserService } from '../common/services/user.service';
import { ConfirmDialog, ConfirmationDialogComponent } from '../dialogs/dialog-unsaved-changes/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { CompetencyTemplateService } from '../common/services/competency-type.service';
import { CompetencyTemplate } from '../common/models/competencyTemplate';
import { Dictionary } from 'lodash';
import { Format } from '../common/models/format';
import { FormatService } from '../common/services/format.service';
import { MatDrawer } from '@angular/material/sidenav';
import * as _ from 'lodash';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Cost } from '../common/models/cost';

@Component({
    selector: 'app-learning-resources',
    templateUrl: './learning-resources.component.html',
    styleUrls: ['./learning-resources.component.css'],
    standalone: false
})

export class LearningResourcesComponent implements OnInit {

  @ViewChild(MatDrawer) drawer: MatDrawer;
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;

  learningResource: LearningResource[];
  topLearningResource: LearningResource[];

  competencyTemplates: Dictionary<CompetencyTemplate[]>;

  filter: Filter = {CostItems: [], FormatItems: [], DomainItems: []};
  formats: Format[];
  costs: Cost[];
  sort = 'recent';
  search: string;

  defaultRecords = 10;
  pageIndex = 0;

  constructor (private learningResourcesService: LearningResourceService, private userService: UserService, private dialog: MatDialog, private competencyTemplateSevice: CompetencyTemplateService, private formatService: FormatService){}

  ngOnInit() {
    document.getElementsByTagName('mat-sidenav-content')[0]?.scrollTo(0, 0);
    this.getFilterList();
    this.userService.user().subscribe((user) => {
      this.learningResourcesService.getRankedLearningResourcesByUserId(user.Id).subscribe((resources) => {
        this.learningResource = [...resources];
        if(resources?.length > 5)
          this.topLearningResource = _.cloneDeep(resources).slice(0, 5);
        else
          this.topLearningResource = _.cloneDeep(resources);
      })
    })
  }

  launchFormatDialog(){
    const confirm = new ConfirmDialog();
      confirm.title = "Format";
      confirm.message = `Resource formats align with the type of learning activities included in your current CPD plan. Experiential resources include hands-on activities and learning from experience. Live events may be virtual
      or in-person and occur at a specific time. Audio podcasts, video recordings and written content are all on-demand content that can be accessed anytime. Self-directed courses are also on-demand and
      may include a combination of written, video or audio content.`;
      confirm.message2 = ""
      confirm.okButtonTitle = "OK";
      confirm.cancelButtonTitle = "";
      this.dialog.open(ConfirmationDialogComponent, {
        width: '875px',
        height: '420px',
        data: confirm,
        disableClose: true,
        ariaLabelledBy: 'confirm-desc',
        panelClass: 'format-panel'
      });
  }

  resetFilters(){
    this.filter.CostItems.forEach(r => r.checked = false);
    this.filter.FormatItems.forEach(r => r.checked = false);
    this.filter.DomainItems.forEach(r => {
      r.allComplete = false;
      r.subtasks.forEach(s => s.checked = false);
    });
    this.paginator.firstPage();
    this.drawer.toggle();
  }

  onPageChange(e: PageEvent){
    this.defaultRecords = e.pageSize;
    this.pageIndex = e.pageIndex;
    document.getElementsByTagName('mat-sidenav-content')[0]?.scrollTo(0, 0);
  }

  getUrl(url: string){
    if(url?.startsWith('https://', 0))
      return url
    else
      return 'https://' + url;
  }

  onOpenFilter(event: boolean) {
    if(event)
      this.userService.refreshUser().subscribe();
  }

  onTabChange() {
    this.userService.refreshUser().subscribe();
  }

  onPageLaunch() {
    this.userService.refreshUser().subscribe();
  }

  resetPage() {
    this.paginator.firstPage();
  }

  getFilterList() {
    this.filter.CostItems.push({area: 'Cost', name: 'Free', checked: false});
    this.filter.CostItems.push({area: 'Cost', name: 'Paid', checked: false});
    this.formatService.getFormats().subscribe(r => {
      r.forEach(format => {
        this.filter.FormatItems.push({area: 'Format', name: format.Name, checked: false});
      });
    });
    this.competencyTemplateSevice.getCompetencyTemplatesGrouped().subscribe(dict => {
      for (const domain in dict){
        const value = dict[domain];
        const panel = {opened: false, allComplete: false, subtasks: [], name: domain};
        value?.forEach(r => {
          panel.subtasks.push({area: 'Competency', name: r.Name, checked: false});
        });
        this.filter.DomainItems.push(panel);
      }
    });
  }
}


export interface Filter {
  CostItems: FilterItems[];
  FormatItems: FilterItems[];
  DomainItems: Panel[];
}

export interface FilterItems {
  area: string;
  name: string;
  checked: boolean;
}

export interface Panel {
  opened: boolean;
  allComplete: boolean;
  subtasks: FilterItems[];
  name: string;
}
